import type { FaireProductEntity } from "../../entity_types/product";

export const p_nm2dqcqu5x: FaireProductEntity = {
  token: "p_nm2dqcqu5x",
  type: "product",
  name: "Matcha Yume organic (40g Tin)",
  brandToken: "b_2b52173f",
  brandName: "Camellia Sinensis",
  imageUrl:
    "https://cdn.faire.com/fastly/e45719cb782cdecdf33c28fac14a925cd74994c8d6b48ce3e60aefab1f0e4d94.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/698ecb7754c4804bb8713c8d69a5806c762951cb3741ed6b129b0167cda089bb.jpeg",
    "https://cdn.faire.com/fastly/626790e20cfcaa9aec1ff9100ab7d7030289118b77fb5319206b40f860fbfc72.jpeg",
    "https://cdn.faire.com/fastly/2894aa1fbede75ccaa4a15c86d2c241b412264911bf9638908ce9baebf2a8143.jpeg",
    "https://cdn.faire.com/fastly/d630019ffcafba3070e9116f9d3f5a29f63d80eeacefea46b445f97af0c494f0.jpeg",
    "https://cdn.faire.com/fastly/6ed7452eea1a2a9bbff040a18e675fd397a4c0ba8dea9d6212982b06535cc49b.jpeg",
    "https://cdn.faire.com/fastly/dee988ea9516bd240a834bfb9f27f6e978c2c07d05a920f613c38e8ae2120200.jpeg",
    "https://cdn.faire.com/fastly/ab5d1c4c438a31a8a4625f227a356a51cb5656dbcdf010eb35d2e66cda278de4.jpeg",
    "https://cdn.faire.com/fastly/6630f54b74f50b398da1a7f517350474302825d4198440ada018cbdc6f384fd5.jpeg",
  ],
  priceDollars: 12.43,
  description:
    "Here is a Ceremonial Grade organic matcha green tea from a spring harvest that comes from Kirishima in Kagoshima Prefecture on Japan's southernmost main island, Kyushu.\n\nBefore emulsifying, the fine powder gives off notes of chocolate milk. The creamy mousse is very easy to obtain, which will please both less experienced amateurs and connoisseurs.The taste of the beverage starts with vegetable notes (endives) and ends with subtle tropical fruit flavours typical of the Yabukita cultivar.\n\nFor greater freshness, the matcha should be used within 6 months of opening and stored in a cool place.",
  tags: [],
  msrpDollars: 20.72,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-31T17:20:42.336Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
